import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'antd'
import { IRole } from 'interfaces/roles'
import { AccessToCoursesEnum } from 'enum/accessToCourses'
import { Courses } from './styled'
import Detail from './detail'

interface IProps {
  role: IRole
}

const AccessToCourses = ({ role }: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.roles.table.headers.accessToCourses'
  const [showDetail, setShowDetail] = useState(false)

  switch (role.accessToCourses) {
    case AccessToCoursesEnum.All:
      return <>{t(`${prefix}.all`)}</>
    case AccessToCoursesEnum.None:
      return <>{t(`${prefix}.none`)}</>
    case AccessToCoursesEnum.Specific:
      return (
        <>
          <Tooltip title={t(`${prefix}.courses.tooltip`)}>
            <Courses onClick={() => setShowDetail(true)}>
              {role.courses.toLocaleString('en-US')}{' '}
              {role.courses === 1
                ? t(`${prefix}.courses.title.singular`)
                : t(`${prefix}.courses.title.plural`)}
              <FontAwesomeIcon icon={faEye} />
            </Courses>
          </Tooltip>
          {showDetail && (
            <Detail role={role} close={() => setShowDetail(false)} />
          )}
        </>
      )
  }
}

export default AccessToCourses
